import { ERR_FETCH_ERROR } from '@/consts/client';

export class FetchError extends Error {
  constructor(
    public readonly status: number,
    public readonly input: string,
  ) {
    super(`${ERR_FETCH_ERROR} ${status} at ${input}`);
    this.name = 'FetchError';
  }
}
